import {
    Clock3,
    CheckCircle2,
    XCircle,
    PauseCircle,
    AlertTriangle,
    PackageCheck,
} from "lucide-react";

const STATUS_CONFIG = {
    Draft: {
        icon: Clock3,
        bg: "bg-amber-50",
        text: "text-amber-700",
        border: "border-amber-200",
    },
    Posted: {
        icon: CheckCircle2,
        bg: "bg-emerald-50",
        text: "text-emerald-700",
        border: "border-emerald-200",
    },
    Cancelled: {
        icon: XCircle,
        bg: "bg-red-50",
        text: "text-red-700",
        border: "border-red-200",
    },
    Pending: {
        icon: PauseCircle,
        bg: "bg-sky-50",
        text: "text-sky-700",
        border: "border-sky-200",
    },
    Partial: {
        icon: AlertTriangle,
        bg: "bg-orange-50",
        text: "text-orange-700",
        border: "border-orange-200",
    },
    Completed: {
        icon: PackageCheck,
        bg: "bg-green-50",
        text: "text-green-700",
        border: "border-green-200",
    },
};

export default function StatusBadge({
    status = "Draft",
    size = "md",
}) {

    const config =
        STATUS_CONFIG[status] || STATUS_CONFIG.Draft;

    const Icon = config.icon;

    const sizes = {
        sm: {
            wrapper: "px-2 py-1 text-xs",
            icon: 12,
        },
        md: {
            wrapper: "px-3 py-1.5 text-sm",
            icon: 15,
        },
        lg: {
            wrapper: "px-4 py-2 text-base",
            icon: 18,
        },
    };

    return (
        <span
            className={`
                inline-flex
                items-center
                gap-2
                rounded-full
                border
                font-medium
                ${config.bg}
                ${config.text}
                ${config.border}
                ${sizes[size].wrapper}
            `}
        >
            <Icon size={sizes[size].icon} />

            {status}
        </span>
    );
}